export const inventura_nedopusteni_manjak = {
  templateId: 209.2,
  category: 4,
  templateTitle: 'Odluka o knjiženju popisnih razlika (nedopušteni manjak)',
  templateDescription: `<p>Inventurom utvrđeni manjkovi nakon usklađivanja s knijgovodstvenim stanjem mogu biti porezni priznati, u slučaju dopuštenog manjka te porezno nepriznati, u slučaju nedopuštenog manjka. </p>`,
  description: `
  <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
  <p>Kao što je već navedeno u tekstu ispred <a class="local-link" href="/contract?template=208">Odluke o imenovanju inventurne komisije</a>, inventurna komisija brojanjem, vaganjem, mjerenjem i drugim postupcima utvrđuje stvarno stanje imovine i unosi ga u popisne liste. </p>
  <p>Nakon navedenog posla, inventurna komisija utvrđuje popisne razlike između knjigovodstvenog stanja i stvarnog stanja te iste konstatira u <a class="local-link" href="/contract?template=209">Izvještaju inventurne komisije</a>.</p>
  <p>Usporedbom podataka dobivenih popisom (stvarno stanje) s podacima iz poslovnih knjiga i evidencija, mogu se utvrditi inventurni viškovi ili manjkovi imovine.</p>
  <p>Najčešće se inventurom utvrdi manjak, a rjeđe, višak imovine.</p>
  <p>U tom smislu, manjkovi utvrđeni inventurom dijele se na:</p>
  <li> neoporezive manjkove, </li>
  <li> oporezive manjkove.</li>
  <br> 
  <p>Ovom odlukom se obrađuje oporezivi - porezno nepriznati manjak.  </p>
  <p>Uvjeti za porezno priznati manjak propisani su Pravilnikom o porezu na dodanu vrijednost.</p>
  <p>Prema navedenom Pravilniku, manjkovima koji, uz ispunjavanje propisanih uvjeta, ne podliježu oporezivanju smatraju se:</p>

  <li> manjkovi dobara nastali djelovanjem više sile,</li>
  <li> tehnološki manjak nastao u procesu proizvodnje do visine utvrđene normativima prema vrsti djelatnosti,</li>
  <li> kalo, rastep, kvar i lom do iznosa utvrđenog odlukom nadležne komore,</li>
  <li> manjkovi dobara zbog neodgovarajuće kvalitete, proteka roka trajanja, kala, rastepa, kvara i loma iznad visine utvrđene odlukom nadležne komore, ako je pri utvrđivanju činjeničnog stanja bio prisutan ovlašteni službenik Porezne uprave ili ako porezni obveznik raspolaže odgovarajućom dokumentacijom nadležnih tijela ili institucija o količini i vrsti preuzetih dobara koja su dana na zbrinjavanje ili uništenje.</li>
  <br> 
  <p>Tek trenutkom knjiženja inventurnih razlika, knjigovodstveno stanje se usklađuje sa stvarnim stanjem utvrđenim popisom.</p>

  <h5><strong>PRAVNA OSNOVA</strong></h5>
  <p>Zakon o računovodstvu, Opći porezni zakon, Pravilnik o porezu na dodanu vrijednost.</p>
  `,
  sides: [
      {
          signature: 'Za Poduzetnika',
          inputs: [{
              type: "input",
              required: true,
              placeholder: "Poslovni subjekt",
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              placeholder: "Zastupa",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija",
              inSignature: true,
            }],
          suffix: ' (u daljnjem tekstu: Poduzetnik),',
      }
  ],

  
  headline: '​donosi sljedeću',
  title: 'ODLUKA O KNJIŽENJU POPISNIH RAZLIKA (NEDOPUŠTENI MANJAK)',
  noArticleNumbers: true,

  articles: [
   
    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              editable: true,
              mandatory: true,
              content: 'Nakon provedene inventure, Popisnim listom br____________od _____________ godine obuhvaćeno je stanje robe - materijala te je istim utvrđen manjak prema tablici koja se nalazi u Privitku ove Odluke. ',
              value: '',
          }],
  },
  
  {
    title: '',
    mandatory: false,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            editable: true,
            mandatory: true,
            content: 'Manjkovi utvrđeni  Popisnim listom navedenim u ovoj Odluci predstavljaju prekomjerni  tehnološki manjak, kalo rastep, kvar i lom iznad dopuštenog manjka, prema Odluci o dopuštenoj visini kala, rastepa, kvara, loma i tehnološkog manjka u ugostiteljstvu. \r\nPrekomjerni manjak iznosi ____ kn.',
            value: '',
        }],
},
{
  title: '',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          editable: true,
          mandatory: true,
          content: 'Na iznos manjka obračunati će se PDV te će se isti tretirati kao porezno nepriznati trošak koji uvećava osnovicu poreza na dobit.',
          value: '',
      }],
},
{
  title: '',
  mandatory: true,
  statements: [
      {
          type: 'choice',
          mandatory: true,
          editable: true,
          choices: [
              'Za iznos manjka teretiti će se Poduzetnik.',
              'Za iznos manjka teretiti će se __________________.',
            ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
      }
  ]
},

{
  title: '',
  mandatory: false,
  statements: [
      {
          type: 'text',
          required: true,
          mandatory: true,
          editable: true,
          content: 'Ova Odluka primjenjuje se od trenutka donošenja.',
          value: '',
      },
  ],
  value: '',
}, 

{
mandatory: true,
static: true,
type: 2, // date and place
statements: [
  {
    type: "input",
    mandatory: true,
    parts: [
      {
        type: "text",
        content: "U"
      },
      {
        type: "input",
        value: "",
        placeholder: "Upišite mjesto.",
        required: true,
      },
      {
        type: "text",
        content: ", dana"
      },
      {
        type: "date",
        value: new Date(),
        required: true
      },
      {
        type: "text",
        content: "godine."
      }
    ]
  },
]
},
{
mandatory: true,
static: true,
type: 3,  // signature
statements: [],
},
{
static: true,
mandatory: false,
type: 4, 
statements: [
  {
    type: 'text',
    mandatory: true,
    editable: true,
    content: 'Dostaviti:\r\n1) Članovima inv. komisije \r\n2) Odjel knjigovodstva',
    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
  }
]
},
],
};






// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/209.2_inventura_nedopusteni_manjak.ts